import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  VStack,
  Tooltip,
  Box,
} from '@chakra-ui/react'
import { QRCodeCanvas } from 'qrcode.react';
import React, { createElement } from 'react'
import { MdQrCode } from 'react-icons/md'
import IconButton from './IconButton'
import Link from './Link';

const size = 256

const CustonQrCode = ({ value }) => {

  return (
    <Box position="relative">
      <QRCodeCanvas size={size} value={value} />
      {/* <Box pos="absolute" top="50%" left="50%" transform="translate(-50%,-50%)">
        <Image src="/android-chrome-192x192.png" alt="Portaly" width={50} height={50} />
      </Box> */}
    </Box>
  )
}

const QrCodeModal = ({ as = IconButton, link, name = '我', ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Tooltip label="QR Code">
        {createElement(as, {
          icon: <MdQrCode size="1.5em" />,
          variant: 'ghost',
          ...props,
          onClick: onOpen,
        })}
      </Tooltip>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center">{name}</ModalHeader>
          <ModalCloseButton />
          <ModalBody as={VStack} pb="6">
            <CustonQrCode value={link} />
            <Link href={link} isExternal>{link}</Link>
          </ModalBody>

          {/* <ModalFooter>
            <Button mr={3} onClick={onClose}>
              關閉
            </Button>
            <Button variant='ghost'>Secondary Action</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  )
}

export default QrCodeModal
